import { motion } from "framer-motion";

// Fait apparaître un titre mot par mot quand il entre à l'écran
export default function WordsReveal({ text = "" }) {
  return (
    <motion.span initial="hidden" whileInView="show" viewport={{ once: true, margin: "-70px" }}
      transition={{ staggerChildren: 0.07 }} aria-label={text}>
      {text.split(" ").map((w, i) => (
        <motion.span key={i} aria-hidden className="inline-block whitespace-pre"
          variants={{ hidden: { opacity: 0, y: "0.6em", filter: "blur(6px)" }, show: { opacity: 1, y: 0, filter: "blur(0px)" } }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}>
          {w}{i < text.split(" ").length - 1 ? " " : ""}
        </motion.span>
      ))}
    </motion.span>
  );
}
